import { Autocomplete, TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { projectsApi } from '../api/projects.api';

interface Props {
  /** Selected project id as a string ('' = none), matching the pages' existing state. */
  value: string;
  onChange: (id: string) => void;
  label?: string;
  helperText?: string;
  sx?: SxProps<Theme>;
}

/**
 * Project picker for EPC screens — replaces the raw numeric "Project ID" input with a
 * searchable dropdown (project code — name), so users select the project they onboarded
 * instead of guessing its id.
 */
export function EpcProjectSelect({ value, onChange, label = 'Project', helperText, sx }: Props) {
  const { data } = useQuery({ queryKey: ['epc-project-lookup'], queryFn: () => projectsApi.list({ limit: 500, sortBy: 'projectName', sortDir: 'asc' }) });
  const projects = data?.data ?? [];
  const selected = projects.find((p) => String(p.id) === value) ?? null;
  return (
    <Autocomplete
      size="small"
      sx={sx ?? { minWidth: 300 }}
      options={projects}
      getOptionLabel={(p) => `${p.projectCode} — ${p.projectName}`}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      value={selected}
      onChange={(_e, v) => onChange(v ? String(v.id) : '')}
      renderInput={(params) => <TextField {...params} label={label} placeholder="Search project…" helperText={helperText} />}
    />
  );
}
